import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse>;

const deleteFormAsset = (id: string): ReturnType => {
    return Request.delete(`/data/forms/${id}/asset`);
};

export default deleteFormAsset;
